import { useAppDispatch } from 'app/hooks';
import { changeSpaceShape } from 'features/structure/structure-thunks';
import ShapeSubmenu from './shape-submenu';

type ChangeShapeSubmenuProps = {
  spaceId: string;
  onClose: () => void;
};

export default function ChangeShapeSubmenu({
  spaceId,
  onClose
}: ChangeShapeSubmenuProps) {
  const dispatch = useAppDispatch();

  return (
    <ShapeSubmenu
      onSelect={(shape) => dispatch(changeSpaceShape({ spaceId, shape }))}
      onClose={onClose}
    />
  );
}
